import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Co... Remove this comment to see the full error message
import { ContextRouter } from 'react-router';
import { Redirect, Route } from 'react-router-dom';

type OwnProps = {
  exact?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: React.ComponentType<any>;
  render?: (router: ContextRouter) => ReactNode;
  path: string;
};
type Props = OwnProps;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const AuthenticatedRoute = ({ component: Component, render, path }: Props) => {
  const { loggedIn } = useSelector((state) => ({
    loggedIn:
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
      state.currentUser && !state.currentUser.isLoading && state.currentUser.id,
  }));
  return (
    <Route
      path={path}
      render={(router: ContextRouter) => {
        if (!loggedIn) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  redirectTo: `${router.location.pathname}?${router.location.search}`,
                  flashMessage: {
                    type: 'LOGIN_REQUIRED',
                  },
                  title:
                    path === '/post-a-listing'
                      ? getText('Log in to Post a Listing')
                      : undefined,
                },
              }}
            />
          );
        }

        if (Component) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/jsx-props-no-spreading
          return <Component {...router} />;
        }

        if (render) {
          return render(router);
        }

        throw new Error('component or render prop is required');
      }}
    />
  );
};

export default AuthenticatedRoute;
